import { render } from "./HeaderIlesdepaix.vue?vue&type=template&id=75399927&scoped=true"
import script from "./HeaderIlesdepaix.vue?vue&type=script&lang=js"
export * from "./HeaderIlesdepaix.vue?vue&type=script&lang=js"

import "./HeaderIlesdepaix.vue?vue&type=style&index=0&id=75399927&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75399927"]])

export default __exports__